// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CloseLightIconSignature {
  Element: SVGSVGElement;
}

export const CloseLightIcon: TOC<CloseLightIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.2882 11.9999L4.00143 19.2867L4.67941 19.9647L11.9662 12.6779L19.3206 20.0323L19.9986 19.3543L12.6442 11.9999L19.9984 4.64569L19.3204 3.96771L11.9662 11.3219L4.6796 4.03532L4.00163 4.71329L11.2882 11.9999Z"/>
</svg>
</template>;